import { render, staticRenderFns } from "./DeliveryEstimateSideBar.vue?vue&type=template&id=b63ff150&scoped=true&"
import script from "./DeliveryEstimateSideBar.vue?vue&type=script&lang=js&"
export * from "./DeliveryEstimateSideBar.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryEstimateSideBar.vue?vue&type=style&index=0&id=b63ff150&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63ff150",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b63ff150')) {
      api.createRecord('b63ff150', component.options)
    } else {
      api.reload('b63ff150', component.options)
    }
    module.hot.accept("./DeliveryEstimateSideBar.vue?vue&type=template&id=b63ff150&scoped=true&", function () {
      api.rerender('b63ff150', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/delivery-dashboard/components/DeliveryEstimateSideBar.vue"
export default component.exports